import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(
          _vm._s(
            _vm.mode == "view"
              ? "Ver solicitud"
              : _vm.mode == "edit"
              ? "Actualizar Solicitud"
              : "Crear solicitud"
          )
        ),
      ]),
      _vm._t("default"),
      _c(
        "actions-component",
        [
          _c(
            "template",
            { slot: "description" },
            [
              _c(VBreadcrumbs, {
                staticClass: "pa-0",
                attrs: { items: _vm.breadcrumbs },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "actions" },
            [
              !(_vm.mode === "view")
                ? _c(
                    VBtn,
                    {
                      staticClass: "ml-1 btn-inca-secondary",
                      attrs: { dense: "", outlined: "" },
                      on: {
                        click: function ($event) {
                          return _vm.addItem_pipe()
                        },
                      },
                    },
                    [
                      _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-plus-circle-outline"),
                      ]),
                      _vm._v("Añadir pipeline"),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        VCard,
        { staticClass: "mt-2" },
        [
          _c(
            VCardText,
            [
              _c(
                VForm,
                { ref: "form" },
                [
                  _vm.mode === "view" || _vm.mode === "edit"
                    ? _c(
                        VRow,
                        { staticClass: "px-2 pt-2" },
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "2" } },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold" },
                                [_vm._v("Código")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { cols: "4" } },
                            [
                              _vm.mode === "view" || _vm.mode === "edit"
                                ? _c(VTextField, {
                                    attrs: {
                                      readonly: "",
                                      filled: "",
                                      dense: "",
                                      value: _vm.model_view.code,
                                      "hide-details": "auto",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { cols: "2" } },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold" },
                                [_vm._v("Applicant")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { cols: "4" } },
                            [
                              _vm.mode === "view" || _vm.mode === "edit"
                                ? _c(VTextField, {
                                    attrs: {
                                      readonly: "",
                                      filled: "",
                                      dense: "",
                                      value: _vm.model_view.applicant,
                                      "hide-details": "auto",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.mode === "view" || _vm.mode === "edit"
                    ? _c(
                        VRow,
                        { staticClass: "px-2 pt-2" },
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "2" } },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold" },
                                [_vm._v("Estado")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { cols: "4" } },
                            [
                              _vm.mode === "view" || _vm.mode === "edit"
                                ? _c(VTextField, {
                                    attrs: {
                                      readonly: "",
                                      filled: "",
                                      dense: "",
                                      value: _vm.model_view.status,
                                      "hide-details": "auto",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { cols: "2" } },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold" },
                                [_vm._v("Fecha Creación")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { cols: "4" } },
                            [
                              _vm.mode === "view" || _vm.mode === "edit"
                                ? _c(VTextField, {
                                    attrs: {
                                      readonly: "",
                                      filled: "",
                                      dense: "",
                                      value: _vm._f("stringGMTFormatDate")(
                                        _vm.model_view.created_date
                                      ),
                                      "hide-details": "auto",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.mode === "view" || _vm.mode === "edit"
                    ? _c(
                        VRow,
                        { staticClass: "px-2 pt-2" },
                        [
                          _vm.model_view.status !== "REQUESTED"
                            ? _c(
                                VCol,
                                { attrs: { cols: "2" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [_vm._v("Respuesta")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            VCol,
                            { attrs: { cols: "4" } },
                            [
                              _vm.model_view.status !== "REQUESTED"
                                ? _c(VTextField, {
                                    attrs: {
                                      readonly: "",
                                      filled: "",
                                      dense: "",
                                      value: _vm.model_view.response,
                                      "hide-details": "auto",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    VRow,
                    { staticClass: "px-2 pt-2" },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v("Proyecto")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "4" } },
                        [
                          _c(VSelect, {
                            key: _vm.key_aux,
                            attrs: {
                              outlined: !(_vm.mode === "view"),
                              readonly: _vm.mode === "view",
                              filled: _vm.mode === "view",
                              dense: "",
                              items: _vm.getMLProjects,
                              "hide-details": "auto",
                              "item-text": "name",
                              "item-value": "id",
                              rules: [
                                function (v) {
                                  return (
                                    !!v || _vm.$t("my_tasks.modals.required")
                                  )
                                },
                              ],
                            },
                            on: {
                              change: function ($event) {
                                return _vm.onChangeProject($event)
                              },
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "item",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _c(
                                      VTooltip,
                                      {
                                        attrs: { top: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function (ref) {
                                                var on = ref.on
                                                return [
                                                  _c(
                                                    "div",
                                                    _vm._g(
                                                      {
                                                        staticClass:
                                                          "v-list-item__title",
                                                      },
                                                      on
                                                    ),
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(item.name)
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            "Business : " +
                                              _vm._s(item.business)
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            "Descripción : " +
                                              _vm._s(item.description)
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            "Entorno : " +
                                              _vm._s(item.environment)
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            "Versión : " + _vm._s(item.version)
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "selection",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _c(
                                      VTooltip,
                                      {
                                        attrs: { top: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function (ref) {
                                                var on = ref.on
                                                return [
                                                  _c("span", _vm._g({}, on), [
                                                    _vm._v(_vm._s(item.name)),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            "Business : " +
                                              _vm._s(item.business)
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            "Descripción : " +
                                              _vm._s(item.description)
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            "Entorno : " +
                                              _vm._s(item.environment)
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            "Versión : " + _vm._s(item.version)
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                            model: {
                              value: _vm.project,
                              callback: function ($$v) {
                                _vm.project = $$v
                              },
                              expression: "project",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v("Configuración")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "4" } },
                        [
                          _c(VSelect, {
                            attrs: {
                              outlined: !(_vm.mode === "view"),
                              readonly: _vm.mode === "view",
                              filled: _vm.mode === "view",
                              dense: "",
                              items: _vm.mlops_configs,
                              "hide-details": "auto",
                              "item-text": "project_id",
                              "item-value": "id",
                              rules: [
                                function (v) {
                                  return (
                                    !!v || _vm.$t("my_tasks.modals.required")
                                  )
                                },
                              ],
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "item",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _c(
                                      VTooltip,
                                      {
                                        attrs: { top: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function (ref) {
                                                var on = ref.on
                                                return [
                                                  _c(
                                                    "div",
                                                    _vm._g(
                                                      {
                                                        staticClass:
                                                          "v-list-item__title",
                                                      },
                                                      on
                                                    ),
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.project_id
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            "Bucket : " +
                                              _vm._s(
                                                item.cloud_storage
                                                  .bucket_pipeline
                                              )
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            "Región : " + _vm._s(item.region)
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            "Cuenta de servicio : " +
                                              _vm._s(
                                                item.service_accounts.execute
                                              )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "selection",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _c(
                                      VTooltip,
                                      {
                                        attrs: { top: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function (ref) {
                                                var on = ref.on
                                                return [
                                                  _c("span", _vm._g({}, on), [
                                                    _vm._v(
                                                      _vm._s(item.project_id)
                                                    ),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            "Bucket : " +
                                              _vm._s(
                                                item.cloud_storage
                                                  .bucket_pipeline
                                              )
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            "Región : " + _vm._s(item.region)
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            "Cuenta de servicio Proceso: " +
                                              _vm._s(
                                                item.service_accounts.process
                                              )
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            "Cuenta de servicio Ejecución: " +
                                              _vm._s(
                                                item.service_accounts.execute
                                              )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                            model: {
                              value: _vm.config,
                              callback: function ($$v) {
                                _vm.config = $$v
                              },
                              expression: "config",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(VDataTable, {
                    key: _vm.key_table,
                    staticClass: "table-inca",
                    attrs: {
                      headers: _vm.headers_tabla,
                      "hide-default-footer": "",
                      items: _vm.pipelines,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item.name",
                        fn: function (data) {
                          return [
                            _c(VTextField, {
                              attrs: {
                                rules: [
                                  function (v) {
                                    return (
                                      !!v || _vm.$t("my_tasks.modals.required")
                                    )
                                  },
                                ],
                                required: "",
                                dense: "",
                                "hide-details": "auto",
                                outlined: !(_vm.mode === "view"),
                                readonly: _vm.mode === "view",
                                filled: _vm.mode === "view",
                              },
                              model: {
                                value: data.item.name,
                                callback: function ($$v) {
                                  _vm.$set(data.item, "name", $$v)
                                },
                                expression: "data.item.name",
                              },
                            }),
                          ]
                        },
                      },
                      {
                        key: "item.version",
                        fn: function (data) {
                          return [
                            _c(VTextarea, {
                              attrs: {
                                rules: [
                                  function (v) {
                                    return (
                                      !!v || _vm.$t("my_tasks.modals.required")
                                    )
                                  },
                                ],
                                required: "",
                                dense: "",
                                "hide-details": "auto",
                                rows: "1",
                                outlined: !(_vm.mode === "view"),
                                readonly: _vm.mode === "view",
                                filled: _vm.mode === "view",
                              },
                              model: {
                                value: data.item.version,
                                callback: function ($$v) {
                                  _vm.$set(data.item, "version", $$v)
                                },
                                expression: "data.item.version",
                              },
                            }),
                          ]
                        },
                      },
                      {
                        key: "item.actions",
                        fn: function (ref) {
                          var item = ref.item
                          var index = ref.index
                          return [
                            _c(
                              VBtn,
                              {
                                staticClass: "btn-icon-inca",
                                attrs: { icon: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.openDialogPipeline(item, index)
                                  },
                                },
                              },
                              [
                                _c(VIcon, { attrs: { small: "" } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.mode == "view"
                                        ? "icon-view"
                                        : "mdi-cog"
                                    )
                                  ),
                                ]),
                              ],
                              1
                            ),
                            !(_vm.mode === "view")
                              ? _c(
                                  VBtn,
                                  {
                                    staticClass: "btn-icon-inca",
                                    attrs: { icon: "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeItem_pipe(index)
                                      },
                                    },
                                  },
                                  [
                                    _c(VIcon, { attrs: { small: "" } }, [
                                      _vm._v("icon-delete"),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VCardActions,
            [
              _c(VSpacer),
              _vm.mode != "view" &&
              _vm.mode != "edit" &&
              !(_vm.pipelines.length == 0)
                ? _c(
                    VBtn,
                    {
                      attrs: { color: "primary" },
                      on: { click: _vm.saveRequest },
                    },
                    [
                      _c(
                        VIcon,
                        { staticClass: "mr-1", attrs: { small: "" } },
                        [_vm._v("mdi-check-circle-outline")]
                      ),
                      _vm._v("Solicitar"),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.mode === "edit" && !(_vm.pipelines.length == 0)
                ? _c(
                    VBtn,
                    {
                      attrs: { color: "primary" },
                      on: { click: _vm.updateRequest },
                    },
                    [
                      _c(
                        VIcon,
                        { staticClass: "mr-1", attrs: { small: "" } },
                        [_vm._v("mdi-check-circle-outline")]
                      ),
                      _vm._v("Actualizar y Solicitar"),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isMLSteward &&
              _vm.mode === "view" &&
              _vm.model_view.status &&
              _vm.model_view.status == "REQUESTED"
                ? _c(
                    VBtn,
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.onApproveRequest()
                        },
                      },
                    },
                    [
                      _c(
                        VIcon,
                        { staticClass: "mr-1", attrs: { small: "" } },
                        [_vm._v("icon-check")]
                      ),
                      _vm._v("Aprobar"),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isMLSteward &&
              _vm.mode === "view" &&
              _vm.model_view.status &&
              _vm.model_view.status == "REQUESTED"
                ? _c(
                    VBtn,
                    {
                      attrs: { color: "default" },
                      on: {
                        click: function ($event) {
                          return _vm.onRejectRequest()
                        },
                      },
                    },
                    [
                      _c(
                        VIcon,
                        { staticClass: "mr-1", attrs: { small: "" } },
                        [_vm._v("icon-decline")]
                      ),
                      _vm._v("Rechazar"),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                VBtn,
                {
                  staticClass: "default mr-1",
                  attrs: {
                    id: "link_list_ml_request",
                    name: "link_list_ml_request",
                    outlined: "",
                  },
                  on: { click: _vm.onVolver },
                },
                [_vm._v(_vm._s(_vm.$t("btns.back")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "DialogConfirmationComponent",
        {
          ref: "MODAL_CONFIRM_APPROVE",
          attrs: {
            title: "Confirmación",
            text: "¿Esta seguro de APROBAR la solicitud?",
          },
          on: { onConfirm: _vm.onConfirmApprove },
        },
        [
          _c("template", { slot: "body" }, [
            _c(
              "div",
              { staticClass: "form--row" },
              [
                _c(
                  VCol,
                  [
                    _c(VTextField, {
                      attrs: {
                        dense: "",
                        label: "Respuesta",
                        outlined: "",
                        "hide-details": "auto",
                      },
                      model: {
                        value: _vm.response,
                        callback: function ($$v) {
                          _vm.response = $$v
                        },
                        expression: "response",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c(
        "DialogConfirmationComponent",
        {
          ref: "MODAL_CONFIRM_REJECT",
          attrs: {
            title: "Confirmación",
            text: "¿Esta seguro de RECHAZAR la solicitud?",
          },
          on: { onConfirm: _vm.onConfirmReject },
        },
        [
          _c("template", { slot: "body" }, [
            _c(
              "div",
              { staticClass: "form--row" },
              [
                _c(
                  VCol,
                  [
                    _c(VTextField, {
                      attrs: {
                        dense: "",
                        label: "Respuesta",
                        outlined: "",
                        "hide-details": "auto",
                      },
                      model: {
                        value: _vm.response,
                        callback: function ($$v) {
                          _vm.response = $$v
                        },
                        expression: "response",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c(
        "DialogsComponent",
        {
          ref: _vm.DIALOG_PIPELINE,
          attrs: { title: "Configurar pipeline", width: 1000 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c(
                VForm,
                { ref: "formDialog" },
                [
                  _c(
                    VRow,
                    { staticClass: "mb-2", attrs: { justify: "center" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: _vm.mode === "view" ? 3 : 2 } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v("Notebook(.ipynb)")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: _vm.mode === "view" ? 9 : 3 } },
                        [
                          _vm.mode === "view"
                            ? _c(VTextField, {
                                attrs: {
                                  dense: "",
                                  outlined: !(_vm.mode === "view"),
                                  readonly: _vm.mode === "view",
                                  filled: _vm.mode === "view",
                                  "hide-details": "auto",
                                  "append-icon": "mdi-download ",
                                },
                                on: {
                                  "click:append": function ($event) {
                                    return _vm.downloadFile(
                                      _vm.pipeline_aux.python_file.route,
                                      _vm.pipeline_aux.python_file.name
                                    )
                                  },
                                },
                                model: {
                                  value: _vm.pipeline_aux.python_file.name,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.pipeline_aux.python_file,
                                      "name",
                                      $$v
                                    )
                                  },
                                  expression: "pipeline_aux.python_file.name",
                                },
                              })
                            : _c("DragFileComponent", {
                                attrs: {
                                  type: ".ipynb,.py",
                                  required: _vm.mode == "edit" ? false : true,
                                },
                                on: {
                                  pdf: function ($event) {
                                    return _vm.getpython($event)
                                  },
                                },
                              }),
                        ],
                        1
                      ),
                      !(_vm.mode === "view")
                        ? _c(
                            VCol,
                            { attrs: { cols: "2" } },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold" },
                                [_vm._v("YAML")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.mode === "view")
                        ? _c(
                            VCol,
                            { attrs: { cols: "3" } },
                            [
                              _c("DragFileComponent", {
                                attrs: {
                                  type: ".yaml",
                                  required: _vm.mode == "edit" ? false : true,
                                },
                                on: {
                                  pdf: function ($event) {
                                    return _vm.getyaml($event)
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm.mode === "view"
                    ? _c(
                        VRow,
                        { staticClass: "mb-2", attrs: { justify: "center" } },
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "3" } },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold" },
                                [_vm._v("YAML")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { cols: "9" } },
                            [
                              _vm.mode === "view"
                                ? _c(VTextField, {
                                    attrs: {
                                      dense: "",
                                      outlined: !(_vm.mode === "view"),
                                      readonly: _vm.mode === "view",
                                      filled: _vm.mode === "view",
                                      "hide-details": "auto",
                                      "append-icon": "mdi-download ",
                                    },
                                    on: {
                                      "click:append": function ($event) {
                                        return _vm.downloadFile(
                                          _vm.pipeline_aux.yaml_file.route,
                                          _vm.pipeline_aux.yaml_file.name
                                        )
                                      },
                                    },
                                    model: {
                                      value: _vm.pipeline_aux.yaml_file.name,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.pipeline_aux.yaml_file,
                                          "name",
                                          $$v
                                        )
                                      },
                                      expression: "pipeline_aux.yaml_file.name",
                                    },
                                  })
                                : _c("DragFileComponent", {
                                    attrs: {
                                      type: ".yaml",
                                      required:
                                        _vm.mode == "edit" ? false : true,
                                    },
                                    on: {
                                      pdf: function ($event) {
                                        return _vm.getyaml($event)
                                      },
                                    },
                                  }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    VRow,
                    { staticClass: "mb-2", attrs: { justify: "center" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v("Label")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9" } },
                        [
                          _c(VDataTable, {
                            staticClass: "table-inca",
                            attrs: {
                              headers: _vm.headers_label,
                              "hide-default-footer": "",
                              items: _vm.labels,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "header.actions",
                                fn: function (ref) {
                                  var header = ref.header
                                  return [
                                    !(_vm.mode === "view")
                                      ? _c(
                                          VBtn,
                                          {
                                            attrs: { icon: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.addItem_label()
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              VIcon,
                                              { attrs: { small: "" } },
                                              [
                                                _vm._v(
                                                  "mdi-plus-circle-outline"
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                              {
                                key: "item.label",
                                fn: function (data) {
                                  return [
                                    _c(VTextField, {
                                      attrs: {
                                        rules: [
                                          function (v) {
                                            return (
                                              !!v ||
                                              _vm.$t("my_tasks.modals.required")
                                            )
                                          },
                                        ],
                                        required: "",
                                        dense: "",
                                        "hide-details": "auto",
                                        outlined: !(_vm.mode === "view"),
                                        readonly: _vm.mode === "view",
                                        filled: _vm.mode === "view",
                                      },
                                      model: {
                                        value: data.item.label,
                                        callback: function ($$v) {
                                          _vm.$set(data.item, "label", $$v)
                                        },
                                        expression: "data.item.label",
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "item.value",
                                fn: function (data) {
                                  return [
                                    _c(VTextField, {
                                      attrs: {
                                        rules: [
                                          function (v) {
                                            return (
                                              !!v ||
                                              _vm.$t("my_tasks.modals.required")
                                            )
                                          },
                                        ],
                                        required: "",
                                        dense: "",
                                        "hide-details": "auto",
                                        rows: "1",
                                        outlined: !(_vm.mode === "view"),
                                        readonly: _vm.mode === "view",
                                        filled: _vm.mode === "view",
                                      },
                                      model: {
                                        value: data.item.value,
                                        callback: function ($$v) {
                                          _vm.$set(data.item, "value", $$v)
                                        },
                                        expression: "data.item.value",
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "item.actions",
                                fn: function (data) {
                                  return [
                                    !(_vm.mode === "view")
                                      ? _c(
                                          VBtn,
                                          {
                                            staticClass: "btn-icon-inca",
                                            attrs: { icon: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeItem_label(
                                                  data
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              VIcon,
                                              { attrs: { small: "" } },
                                              [_vm._v("icon-delete")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    { staticClass: "mb-2", attrs: { justify: "center" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v(_vm._s(_vm.$t("help_center.description")))]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9" } },
                        [
                          _c(VTextarea, {
                            attrs: {
                              rules: [
                                function (v) {
                                  return (
                                    !!v || _vm.$t("my_tasks.modals.required")
                                  )
                                },
                              ],
                              outlined: !(_vm.mode === "view"),
                              readonly: _vm.mode === "view",
                              filled: _vm.mode === "view",
                              rows: "3",
                              "hide-details": "auto",
                            },
                            model: {
                              value: _vm.pipeline_aux.description,
                              callback: function ($$v) {
                                _vm.$set(_vm.pipeline_aux, "description", $$v)
                              },
                              expression: "pipeline_aux.description",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    { staticClass: "mb-2", attrs: { justify: "center" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v("Parámetros")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9" } },
                        [
                          _c(VDataTable, {
                            staticClass: "table-inca",
                            attrs: {
                              headers: _vm.headers_terms,
                              "hide-default-footer": "",
                              items: _vm.parameters,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "header.actions",
                                fn: function (ref) {
                                  var header = ref.header
                                  return [
                                    !(_vm.mode === "view")
                                      ? _c(
                                          VBtn,
                                          {
                                            attrs: { icon: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.addItem()
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              VIcon,
                                              { attrs: { small: "" } },
                                              [
                                                _vm._v(
                                                  "mdi-plus-circle-outline"
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                              {
                                key: "item.name",
                                fn: function (data) {
                                  return [
                                    _c(VTextField, {
                                      attrs: {
                                        rules: [
                                          function (v) {
                                            return (
                                              !!v ||
                                              _vm.$t("my_tasks.modals.required")
                                            )
                                          },
                                        ],
                                        required: "",
                                        dense: "",
                                        "hide-details": "auto",
                                        outlined: !(_vm.mode === "view"),
                                        readonly: _vm.mode === "view",
                                        filled: _vm.mode === "view",
                                      },
                                      model: {
                                        value: data.item.name,
                                        callback: function ($$v) {
                                          _vm.$set(data.item, "name", $$v)
                                        },
                                        expression: "data.item.name",
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "item.description",
                                fn: function (data) {
                                  return [
                                    _c(VTextarea, {
                                      attrs: {
                                        rules: [
                                          function (v) {
                                            return (
                                              !!v ||
                                              _vm.$t("my_tasks.modals.required")
                                            )
                                          },
                                        ],
                                        required: "",
                                        dense: "",
                                        "hide-details": "auto",
                                        rows: "1",
                                        outlined: !(_vm.mode === "view"),
                                        readonly: _vm.mode === "view",
                                        filled: _vm.mode === "view",
                                      },
                                      model: {
                                        value: data.item.description,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            data.item,
                                            "description",
                                            $$v
                                          )
                                        },
                                        expression: "data.item.description",
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "item.type",
                                fn: function (data) {
                                  return [
                                    _c(VSelect, {
                                      attrs: {
                                        items: _vm.parameter_types,
                                        rules: [
                                          function (v) {
                                            return (
                                              !!v ||
                                              _vm.$t("my_tasks.modals.required")
                                            )
                                          },
                                        ],
                                        required: "",
                                        dense: "",
                                        "hide-details": "auto",
                                        outlined: !(_vm.mode === "view"),
                                        readonly: _vm.mode === "view",
                                        filled: _vm.mode === "view",
                                      },
                                      model: {
                                        value: data.item.type,
                                        callback: function ($$v) {
                                          _vm.$set(data.item, "type", $$v)
                                        },
                                        expression: "data.item.type",
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "item.default",
                                fn: function (data) {
                                  return [
                                    ["str", "int", "float"].includes(
                                      data.item.type
                                    )
                                      ? _c(VTextField, {
                                          attrs: {
                                            rules: [
                                              function (v) {
                                                return (
                                                  !!v ||
                                                  _vm.$t(
                                                    "my_tasks.modals.required"
                                                  )
                                                )
                                              },
                                            ],
                                            required: "",
                                            dense: "",
                                            "hide-details": "auto",
                                            outlined: !(_vm.mode === "view"),
                                            readonly: _vm.mode === "view",
                                            filled: _vm.mode === "view",
                                          },
                                          model: {
                                            value: data.item.default,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                data.item,
                                                "default",
                                                $$v
                                              )
                                            },
                                            expression: "data.item.default",
                                          },
                                        })
                                      : _vm._e(),
                                    ["boolean"].includes(data.item.type)
                                      ? _c(VCheckbox, {
                                          attrs: {
                                            required: "",
                                            dense: "",
                                            "hide-details": "auto",
                                          },
                                          model: {
                                            value: data.item.default,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                data.item,
                                                "default",
                                                $$v
                                              )
                                            },
                                            expression: "data.item.default",
                                          },
                                        })
                                      : _vm._e(),
                                    ["typing.List", "typing.Dict"].includes(
                                      data.item.type
                                    )
                                      ? _c(VTextarea, {
                                          attrs: {
                                            rules: [
                                              function (v) {
                                                return (
                                                  !!v ||
                                                  _vm.$t(
                                                    "my_tasks.modals.required"
                                                  )
                                                )
                                              },
                                            ],
                                            placeholder:
                                              data.item.type == "typing.List"
                                                ? "[]"
                                                : "{}",
                                            required: "",
                                            dense: "",
                                            "hide-details": "auto",
                                            outlined: !(_vm.mode === "view"),
                                            readonly: _vm.mode === "view",
                                            filled: _vm.mode === "view",
                                          },
                                          model: {
                                            value: data.item.default,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                data.item,
                                                "default",
                                                $$v
                                              )
                                            },
                                            expression: "data.item.default",
                                          },
                                        })
                                      : _vm._e(),
                                  ]
                                },
                              },
                              {
                                key: "item.actions",
                                fn: function (data) {
                                  return [
                                    !(_vm.mode === "view")
                                      ? _c(
                                          VBtn,
                                          {
                                            staticClass: "btn-icon-inca",
                                            attrs: { icon: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeItem(data)
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              VIcon,
                                              { attrs: { small: "" } },
                                              [_vm._v("icon-delete")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    { staticClass: "mb-2", attrs: { justify: "center" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v("Archivos")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9" } },
                        [
                          _c("span", [
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  "Folder: gs://{bucket}/" +
                                    _vm.getNameFolderProject +
                                    "/" +
                                    _vm.getNameFolderPipe(
                                      _vm.pipeline_aux.name
                                    ) +
                                    "/data/"
                                )
                              ),
                            ]),
                          ]),
                          _c(VDataTable, {
                            key: _vm.key_archivos,
                            staticClass: "table-inca",
                            attrs: {
                              headers: _vm.headers_archivos,
                              "hide-default-footer": "",
                              items: _vm.archivos,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "header.actions",
                                fn: function (ref) {
                                  var header = ref.header
                                  return [
                                    !(_vm.mode === "view")
                                      ? _c(
                                          VBtn,
                                          {
                                            attrs: { icon: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.addItem_archivo()
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              VIcon,
                                              { attrs: { small: "" } },
                                              [
                                                _vm._v(
                                                  "mdi-plus-circle-outline"
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                              {
                                key: "item.folder",
                                fn: function (ref) {
                                  var item = ref.item
                                  var index = ref.index
                                  return [
                                    _c(VTextField, {
                                      attrs: {
                                        value: item.folder,
                                        dense: "",
                                        "hide-details": "auto",
                                        outlined: !(_vm.mode === "view"),
                                        readonly: _vm.mode === "view",
                                        filled: _vm.mode === "view",
                                      },
                                      model: {
                                        value: item.folder,
                                        callback: function ($$v) {
                                          _vm.$set(item, "folder", $$v)
                                        },
                                        expression: "item.folder",
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "item.name",
                                fn: function (ref) {
                                  var item = ref.item
                                  var index = ref.index
                                  return [
                                    _c(VTextField, {
                                      attrs: {
                                        rules: [
                                          function (v) {
                                            return (
                                              !!v ||
                                              _vm.$t("my_tasks.modals.required")
                                            )
                                          },
                                        ],
                                        value: item.name,
                                        required: "",
                                        dense: "",
                                        "hide-details": "auto",
                                        outlined: !(_vm.mode === "view"),
                                        readonly: _vm.mode === "view",
                                        filled: _vm.mode === "view",
                                      },
                                      model: {
                                        value: item.name,
                                        callback: function ($$v) {
                                          _vm.$set(item, "name", $$v)
                                        },
                                        expression: "item.name",
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "item.is_schema",
                                fn: function (data) {
                                  return [
                                    _c(VCheckbox, {
                                      attrs: {
                                        dense: "",
                                        "hide-details": "auto",
                                        readonly: _vm.mode === "view",
                                      },
                                      model: {
                                        value: data.item.is_schema,
                                        callback: function ($$v) {
                                          _vm.$set(data.item, "is_schema", $$v)
                                        },
                                        expression: "data.item.is_schema",
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "item.archivo",
                                fn: function (ref) {
                                  var data = ref.data
                                  var index = ref.index
                                  return [
                                    _vm.mode === "view"
                                      ? _c(VTextField, {
                                          attrs: {
                                            dense: "",
                                            outlined: !(_vm.mode === "view"),
                                            readonly: _vm.mode === "view",
                                            filled: _vm.mode === "view",
                                            "hide-details": "auto",
                                            "append-icon": "mdi-download ",
                                          },
                                          on: {
                                            "click:append": function ($event) {
                                              return _vm.downloadFile(
                                                _vm.pipeline_aux.archivos[index]
                                                  .archivo_file.route,
                                                _vm.pipeline_aux.archivos[index]
                                                  .archivo_file.name
                                              )
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.pipeline_aux.archivos[index]
                                                .archivo_file.name,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.pipeline_aux.archivos[index]
                                                  .archivo_file,
                                                "name",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "pipeline_aux.archivos[index].archivo_file.name",
                                          },
                                        })
                                      : _c(VFileInput, {
                                          attrs: {
                                            rules:
                                              _vm.mode == "edit"
                                                ? []
                                                : [
                                                    function (v) {
                                                      return (
                                                        !!v ||
                                                        _vm.$t(
                                                          "my_tasks.modals.required"
                                                        )
                                                      )
                                                    },
                                                  ],
                                            required:
                                              _vm.mode == "edit" ? false : true,
                                            accept: "*.*",
                                            "prepend-icon": "",
                                            "show-size": "",
                                            outlined: "",
                                            placeholder: "Seleccionar archivo",
                                            dense: "",
                                            "hide-details": "auto",
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.getarchivo(
                                                $event,
                                                index
                                              )
                                            },
                                          },
                                          model: {
                                            value: _vm.archivos[index].archivo,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.archivos[index],
                                                "archivo",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "archivos[index].archivo",
                                          },
                                        }),
                                  ]
                                },
                              },
                              {
                                key: "item.actions",
                                fn: function (data) {
                                  return [
                                    !(_vm.mode === "view")
                                      ? _c(
                                          VBtn,
                                          {
                                            staticClass: "btn-icon-inca",
                                            attrs: { icon: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeItem_archivo(
                                                  data
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              VIcon,
                                              { attrs: { small: "" } },
                                              [_vm._v("icon-delete")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    { staticClass: "mb-2", attrs: { justify: "center" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v("Registro de cambios")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9" } },
                        [
                          _c(VTextarea, {
                            attrs: {
                              rules: [
                                function (v) {
                                  return (
                                    !!v || _vm.$t("my_tasks.modals.required")
                                  )
                                },
                              ],
                              outlined: !(_vm.mode === "view"),
                              readonly: _vm.mode === "view",
                              filled: _vm.mode === "view",
                              rows: "3",
                            },
                            model: {
                              value: _vm.pipeline_aux.changes,
                              callback: function ($$v) {
                                _vm.$set(_vm.pipeline_aux, "changes", $$v)
                              },
                              expression: "pipeline_aux.changes",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    { staticClass: "mb-2" },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v("Variables de Ambiente")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9" } },
                        [
                          _c(VDataTable, {
                            key: _vm.key_envars,
                            staticClass: "table-inca",
                            attrs: {
                              headers: _vm.headers_envars,
                              "hide-default-footer": "",
                              items: _vm.envars,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "header.actions",
                                fn: function (ref) {
                                  var header = ref.header
                                  return [
                                    !(_vm.mode === "view")
                                      ? _c(
                                          VBtn,
                                          {
                                            attrs: { icon: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.addItemEnvar()
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              VIcon,
                                              { attrs: { small: "" } },
                                              [
                                                _vm._v(
                                                  "mdi-plus-circle-outline"
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                              {
                                key: "item.key",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _c(VTextField, {
                                      attrs: {
                                        rules: [
                                          function (v) {
                                            return (
                                              !!v ||
                                              _vm.$t("my_tasks.modals.required")
                                            )
                                          },
                                        ],
                                        value: item.key,
                                        required: "",
                                        dense: "",
                                        "hide-details": "auto",
                                        outlined: !(_vm.mode === "view"),
                                        readonly: _vm.mode === "view",
                                        filled: _vm.mode === "view",
                                      },
                                      model: {
                                        value: item.key,
                                        callback: function ($$v) {
                                          _vm.$set(item, "key", $$v)
                                        },
                                        expression: "item.key",
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "item.is_file",
                                fn: function (data) {
                                  return [
                                    _c(VCheckbox, {
                                      attrs: {
                                        dense: "",
                                        "hide-details": "auto",
                                        readonly: _vm.mode === "view",
                                      },
                                      model: {
                                        value: data.item.is_file,
                                        callback: function ($$v) {
                                          _vm.$set(data.item, "is_file", $$v)
                                        },
                                        expression: "data.item.is_file",
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "item.value",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    item.is_file && !(_vm.mode === "view")
                                      ? _c(VSelect, {
                                          attrs: {
                                            items: _vm.onGetArchivosEnv,
                                            rules: [
                                              function (v) {
                                                return (
                                                  !!v ||
                                                  _vm.$t(
                                                    "my_tasks.modals.required"
                                                  )
                                                )
                                              },
                                            ],
                                            required: "",
                                            dense: "",
                                            "hide-details": "auto",
                                            "item-text": "name",
                                            outlined: !(_vm.mode === "view"),
                                            readonly: _vm.mode === "view",
                                            filled: _vm.mode === "view",
                                            "return-object": "",
                                          },
                                          model: {
                                            value: item.file,
                                            callback: function ($$v) {
                                              _vm.$set(item, "file", $$v)
                                            },
                                            expression: "item.file",
                                          },
                                        })
                                      : _vm._e(),
                                    item.is_file && _vm.mode === "view"
                                      ? _c(VTextField, {
                                          attrs: {
                                            rules: [
                                              function (v) {
                                                return (
                                                  !!v ||
                                                  _vm.$t(
                                                    "my_tasks.modals.required"
                                                  )
                                                )
                                              },
                                            ],
                                            value: item.file.name,
                                            required: "",
                                            dense: "",
                                            "hide-details": "auto",
                                            outlined: !(_vm.mode === "view"),
                                            readonly: _vm.mode === "view",
                                            filled: _vm.mode === "view",
                                          },
                                        })
                                      : _vm._e(),
                                    !item.is_file
                                      ? _c(VTextField, {
                                          attrs: {
                                            rules: [
                                              function (v) {
                                                return (
                                                  !!v ||
                                                  _vm.$t(
                                                    "my_tasks.modals.required"
                                                  )
                                                )
                                              },
                                            ],
                                            value: item.value,
                                            required: "",
                                            dense: "",
                                            "hide-details": "auto",
                                            outlined: !(_vm.mode === "view"),
                                            readonly: _vm.mode === "view",
                                            filled: _vm.mode === "view",
                                          },
                                          model: {
                                            value: item.value,
                                            callback: function ($$v) {
                                              _vm.$set(item, "value", $$v)
                                            },
                                            expression: "item.value",
                                          },
                                        })
                                      : _vm._e(),
                                  ]
                                },
                              },
                              {
                                key: "item.actions",
                                fn: function (data) {
                                  return [
                                    !(_vm.mode === "view")
                                      ? _c(
                                          VBtn,
                                          {
                                            staticClass: "btn-icon-inca",
                                            attrs: { icon: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeItem_envar(
                                                  data
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              VIcon,
                                              { attrs: { small: "" } },
                                              [_vm._v("icon-delete")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              !(_vm.mode === "view")
                ? _c(
                    VBtn,
                    {
                      attrs: { color: "primary" },
                      on: { click: _vm.saveConfig },
                    },
                    [
                      _c(
                        VIcon,
                        { staticClass: "mr-1", attrs: { small: "" } },
                        [_vm._v("mdi-check-circle-outline")]
                      ),
                      _vm._v(_vm._s(_vm.$t("botones.boton_aceptar"))),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }